<script lang="ts" setup>
export type PageHeaderLinkItem = {
    title: string
    data: PageHeaderLinksBoxLink[]
}

export interface PageHeaderLinksProps {
    data: PageHeaderLinkItem[]
}

const props = defineProps<PageHeaderLinksProps>()
</script>
<template>
  <ContainerFluid
    class="page-header-links position-relative z-index-10 mb-15 mt-n15 mt-lg-n20"
  >
    <div class="row">
      <div class="col-12 col-md-6 mb-4 mb-md-0">
        <PageHeaderLinksBox
          data-cy="header_link_box_discounts"
          :heading="props.data[0]?.title ?? ''"
          :show-subtitle="true"
          background-color="green-1"
          :links="props.data[0]?.data ?? []"
        />
      </div>
      <div class="col-12 col-md-6">
        <PageHeaderLinksBox
          data-cy="header_link_box_quick_links"
          background-color="black-10"
          :heading="props.data[1]?.title ?? ''"
          :links="props.data[1]?.data ?? []"
        />
      </div>
    </div>
  </ContainerFluid>
</template>
